"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardLive = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function CardLive(_a) {
    var className = _a.className, video = _a.video, to = _a.to;
    return react_1.default.createElement("a", { className: storybook_1.Helpers.classNames(className, 'storybook-videos-card-live'), href: to || process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/videos/" + video.slug },
        react_1.default.createElement("div", { style: { backgroundImage: "url(" + video.thumbnail + ")" }, className: 'storybook-videos-card-live-wrapper mb-2' },
            react_1.default.createElement("div", { className: 'storybook-videos-card-live-text-wrapper' },
                react_1.default.createElement("span", { className: 'storybook-videos-card-live-type' },
                    react_1.default.createElement("span", null),
                    "Live"),
                react_1.default.createElement("span", { className: storybook_1.Helpers.classNames(className, 'storybook-videos-card-live-sport') },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: video.sport.name })),
                react_1.default.createElement(storybook_1.Videos.CardTitle, { className: 'storybook-videos-card-live-title' }, video.title))));
}
exports.CardLive = CardLive;
CardLive.propTypes = {
    /**
     * Use a different classname mostly for color binding
     */
    className: prop_types_1.default.string,
    to: prop_types_1.default.string,
    video: prop_types_1.default.shape({
        /**
         * The title of the Video
         */
        title: prop_types_1.default.string,
        /**
         * url of the video thumbnail
         */
        thumbnail: prop_types_1.default.string,
    }).isRequired,
};
